<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const props = defineProps({
  track: {
    type: Array,
    required: true,
  },
});

const mapElement = ref(null);
let map = null;
let routeLine = null;

const drawTrack = async (track) => {
  if (!map || !Array.isArray(track) || track.length < 2) {
    return;
  }

  if (routeLine) {
    map.removeLayer(routeLine);
    routeLine = null;
  }

  routeLine = L.polyline(track, {
    color: '#d62828',
    weight: 5,
    opacity: 0.95,
  }).addTo(map);

  map.fitBounds(routeLine.getBounds(), {
    padding: [24, 24],
    maxZoom: 16,
  });

  await nextTick();
  map.invalidateSize();
};

onMounted(() => {
  if (!mapElement.value) {
    return;
  }

  map = L.map(mapElement.value, {
    zoomControl: true,
    attributionControl: true,
  });

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; OpenStreetMap contributors',
  }).addTo(map);

  drawTrack(props.track);
});

watch(
  () => props.track,
  (track) => {
    drawTrack(track);
  },
  { deep: true }
);

onBeforeUnmount(() => {
  if (map) {
    map.remove();
    map = null;
  }
});
</script>

<template>
  <div
    ref="mapElement"
    class="route-map"
  />
</template>

<style scoped>
.route-map {
  width: 100%;
  height: 280px;
  border-radius: 10px;
  border: 1px solid #c8c8c8;
  overflow: hidden;
}

@media (min-width: 720px) {
  .route-map {
    height: 360px;
  }
}
</style>
